// src/pages/MenuPage.js
import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import '../styles/MenuPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from '../components/Footer';

import image1  from '../assets/menu1.jpg';
import image2  from '../assets/menu2.jpg';
import image3  from '../assets/menu3.jpg';
import image4  from '../assets/menu4.jpg';
import image5  from '../assets/menu5.jpg';
import image6  from '../assets/menu6.jpg';
import image7  from '../assets/menu7.jpg';
import image8  from '../assets/menu8.jpg';
import image9  from '../assets/menu9.jpg';
import image10 from '../assets/menu10.jpg';
import image11 from '../assets/menu11.jpg';
import image12 from '../assets/menu12.jpg';
import image13 from '../assets/menu13.jpg';
import image14 from '../assets/menu14.jpg';
import image16 from '../assets/menu16.jpg';
import image17 from '../assets/menu17.jpg';
import image18 from '../assets/menu18.jpg';
import image19 from '../assets/menu19.jpg';
import image20 from '../assets/menu20.jpg';
import image21 from '../assets/menu21.jpg';
import image22 from '../assets/menu22.jpg';
import image23 from '../assets/menu23.jpg';
import image24 from '../assets/menu24.jpg';
import image25 from '../assets/menu25.jpg';

const IMAGES = [
  image1,  image2,  image3,  image4,  image5,
  image6,  image7,  image8,  image9,  image10,
  image11, image12, image13, image14, image16,
  image17, image18, image19, image20, image21,
  image22, image23, image24, image25,
];

const TOTAL = IMAGES.length;

const MenuPage = () => {
  const [current, setCurrent] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 450,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    afterChange: (i) => setCurrent(i),
  };

  const prev = () => sliderRef.current.slickPrev();
  const next = () => sliderRef.current.slickNext();

  const progressPct = ((current + 1) / TOTAL) * 100;

  return (
    <div className="menu-page">
      <header className="menu-page__header">
        <span className="menu-page__eyebrow">Browse</span>
        <h1 className="menu-page__title">Our Menu</h1>
        <p className="menu-page__sub">
          Use the arrows or swipe to browse. Contact us on WhatsApp for reservations.
        </p>
      </header>

      <div className="menu-carousel-wrap">

        {/* Image + overlaid arrows */}
        <div className="menu-slide-wrap">
          <Slider ref={sliderRef} {...settings}>
            {IMAGES.map((img, i) => (
              <div key={i} className="menu-slide">
                <img
                  src={img}
                  alt={`Menu page ${i + 1}`}
                  loading={i === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
          </Slider>

          {/* Arrows overlaid on image */}
          <button className="menu-arrow menu-arrow--prev" onClick={prev} aria-label="Previous page">
            &#8592;
          </button>
          <button className="menu-arrow menu-arrow--next" onClick={next} aria-label="Next page">
            &#8594;
          </button>
        </div>

        {/* Progress bar + counter */}
        <div className="menu-counter-bar">
          <span className="menu-counter">{current + 1} / {TOTAL}</span>
          <div className="menu-progress" role="progressbar" aria-valuenow={current + 1} aria-valuemax={TOTAL}>
            <div className="menu-progress__fill" style={{ width: `${progressPct}%` }} />
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default MenuPage;
